<script setup lang="ts">
import { ref } from 'vue';
import { toUpperAlphaNum } from '@/utils/string_convert_procs'
import ValidationMessage from '@/components/ui/ValidationMessage.vue'
import { Field } from 'vee-validate'

const props = defineProps<{
  modelValue: string,
  errorMessage?: string,
  nameForValidation: string,
}>()

const emits = defineEmits<{
  (event: "update:modelValue", code: string): void;
}>()

const codeMaxLength = 4

function emitValue(e: Event) {
  const elem = e.target
  if (!(elem instanceof HTMLInputElement)) return
  const modValue = toUpperAlphaNum(elem.value).slice(0, codeMaxLength)
  emits('update:modelValue', modValue)
  elem.value = modValue // ※props.modelValueがセットされないケースがあり、上書きしている（原因不明）
}

const codeInputElement = ref<InstanceType<typeof HTMLInputElement>>();
const focusElement = () => {
  codeInputElement.value?.focus()
}
defineExpose({
  focusElement,
})
</script>

<template>
  <ValidationMessage
    :errorMessage="props.errorMessage"
    :no-display-error-message="true">
    <Field 
      :modelValue="props.modelValue"
      :name="props.nameForValidation"
      v-slot="{ field }">
      <input
        type="text" 
        inputmode="email"
        :maxlength="codeMaxLength"
        autocomplete="off"
        :value="props.modelValue"
        ref="codeInputElement"
        @input="emitValue"
        v-bind="field"/>
    </Field>
  </ValidationMessage>
</template>
